import { render, staticRenderFns } from "./requirementDetail.vue?vue&type=template&id=6efb7b9e&scoped=true&"
import script from "./requirementDetail.vue?vue&type=script&lang=ts&"
export * from "./requirementDetail.vue?vue&type=script&lang=ts&"
import style0 from "./requirementDetail.vue?vue&type=style&index=0&id=6efb7b9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb7b9e",
  null
  
)

export default component.exports